import { Dispatch, FunctionComponent, SetStateAction } from "react";
import { Employee } from "../../services/EventService";
import { Col, Modal, Row, Image } from "react-bootstrap";
import Markdown from "markdown-to-jsx";

interface SpeakerDetailModalProps {
    show: boolean;
    speaker: Employee;
    setShowDetail: Dispatch<SetStateAction<boolean>>;
}

const VITE_STRAPI_IMAGE_BASE_URL: string = import.meta.env.VITE_STRAPI_IMAGE_BASE_URL;

const SpeakerDetailModal: FunctionComponent<SpeakerDetailModalProps> = (props) => {
    const { show, speaker, setShowDetail } = props;

    return (
        <Modal className="speaker__detail_modal" backdrop centered show={show} scrollable onHide={() => setShowDetail(false)}>
            <Modal.Header className="pb-1 pt-4 px-4" closeButton onHide={() => setShowDetail(false)}>
                <Modal.Title>
                    <Row>
                        <Col>
                            <strong>{`${speaker.title !== null ? speaker.title : ''} ${speaker.firstname} ${speaker.name}`}</strong>
                        </Col>
                    </Row>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-2 px-4 pb-4">
                <Row>
                    <Col>
                        <h3 className="event__agenda-item-title"></h3>
                    </Col>
                </Row>
                {speaker.image &&
                    <Row className="mb-4">
                        <Col></Col>
                        <Col>
                            <Image className="rounded-circle my-3 event__speaker-image" width={200} height={200} src={`${VITE_STRAPI_IMAGE_BASE_URL}${speaker.image.url}`} />
                        </Col>
                        <Col></Col>
                    </Row>
                }
                <Row className="mb-4">
                    <Col>
                        {speaker.linkedin_url &&
                            <div>
                                <a className="mb-1" href={speaker.linkedin_url} target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="20px" width="20px" viewBox="0 0 448 512"><path opacity="1" fill="#1E3050" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg>
                                </a>
                            </div>
                        }
                        <p className="p-0 my-0 event__speaker-name">{speaker.title} {speaker.firstname} {speaker.name}</p>
                        <p className="p-0 my-0 event__speaker-company"><small>{speaker.jobtitle} | {speaker.company}</small></p>
                    </Col>
                </Row>
                {speaker.resume &&
                    <Markdown className="event__agenda-item-description">{speaker.resume}</Markdown>
                }
            </Modal.Body>
        </Modal>
    )
}

export default SpeakerDetailModal;